<template>
    <div class="row">
        <div class="col-12">
            <div class="form-group pb-1">
                <div class="checkbox-container mb-3 pb-1">
                    <input 
                        type="checkbox" 
                        name="privacidad" 
                        id="privacidad" 
                        :disabled="desactivar"
                        :class="!privacidad && error ? 'is-invalid' : ''" 
                        v-model="privacidad"
                        @change="condicionesAceptadas"
                    />
                    <label 
                        for="privacidad" 
                        :class="[carrito ? 'with-before' : '']"
                    >
                        {{ $t('formularios.he_leido') }}
                        <router-link :to="{ name: 'legal' }" target="_blank">
                            <span>{{ $t('formularios.terminos_condiciones') }}</span>
                        </router-link>
                        y la
                        <router-link :to="{ name: 'privacidad' }" target="_blank">
                            <span>{{ $t('formularios.politica_privacidad') }}</span>
                        </router-link>
                    </label>
                </div>
                <span class="error" v-if="!privacidad && error">{{ $t('formularios.error_terminos') }}</span>
            </div>
            <div class="form-group pb-1">
                <div class="checkbox-container mb-3 pb-1">
                    <input 
                        type="checkbox" 
                        name="condiciones" 
                        id="condiciones" 
                        :disabled="desactivar"
                        :class="!condiciones && error ? 'is-invalid' : ''" 
                        v-model="condiciones"
                        @change="condicionesAceptadas"
                    />
                    <label for="condiciones" :class="[carrito ? 'with-before' : '']">{{ $t('formularios.acepto') }}
                        <router-link :to="{ name: 'condiciones_generales'}" target="_blank">
                            <span>{{ $t('formularios.condiciones') }}</span>
                        </router-link>
                        {{ visibilidad_reducida ? $t(terminoVisibilidadReducidaKey) : '' }}
                    </label>
                </div>
                <span class="error" v-if="!condiciones && error">{{ $t('formularios.error_condiciones') }}</span>
            </div>
            <div class="form-group pb-1">
                <div class="checkbox-container mb-3 pb-1">
                    <input 
                        type="checkbox" 
                        name="comunicaciones" 
                        id="comunicaciones" 
                        :disabled="desactivar"
                        v-model="comunicaciones" 
                        @change="condicionesAceptadas"
                    />
                    <label for="comunicaciones" :class="[carrito ? 'with-before' : '']">
                        {{ $t('formularios.acepto_comunicaciones', { teatro: getNombreTeatro() })}}
                    </label>
                </div>
                <span class="error" v-if="comunicacionesObligatorias && !comunicaciones && error">{{ $t('formularios.error_comunicaciones') }}</span>
            </div>
            <div class="form-group pb-1" v-if="pago_plazos">
                <div class="checkbox-container mb-4">
                    <input 
                        type="checkbox" 
                        name="plazos" 
                        id="plazos" 
                        :disabled="desactivar" 
                        v-model="plazos"
                        @change="condicionesAceptadas"
                    />
                    <label for="plazos">
                        {{ $t('formularios.acepto_plazos') }}
                        <b>
                            <span class="underline m-0 p-0" @click="showModal('condiciones-plazos')">{{
                                $t('formularios.condiciones_plazos') }}
                            </span>
                        </b>
                        {{ $t('formularios.pago_plazos') }}
                    </label>
                </div>
                <span class="error" v-if="!plazos && error">{{ $t('formularios.error_condiciones_plazos') }}</span>
                <CondicionesPlazosModal 
                    :condiciones_plazos="condiciones_plazos" 
                    :texto_condiciones="texto_condiciones"
                    @close="closeModal"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import CondicionesPlazosModal from './modals/CondicionesPlazosModal';
    import { claveVisibilidad } from '@/utils/visibilidadReducida';

    export default {
        props: ['error', 'pago_plazos', 'condiciones_plazos', 'texto_condiciones', 'desactivar', 'carrito', 'visibilidad_reducida', 'comunicacionesObligatorias'],
        data() {
            return {
                privacidad: false,
                condiciones: false,
                comunicaciones: false,
                plazos: false,
            }
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            condicionesAceptadas() {
                let continuar = false;

                if (this.privacidad && this.condiciones) {
                    continuar = true;

                    if (this.pago_plazos && !this.plazos) {
                        continuar = false;
                    }
                }

                this.$emit(
                    'continuar',
                    continuar,
                    this.privacidad,
                    this.condiciones,
                    this.comunicaciones,
                    this.plazos,
                    this.renovacion_automatica
                );
            },
            getNombreTeatro() {
                if(this.evento_id == 14878 || this.evento_id == 14876) {
                    return 'POWERED BY SHAREMUSIC';
                }
                return this.teatro.nombre;
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            evento_id() {
                return parseInt(this.$route.params.event_id);
            },
            sesion_id() {
                return this.$route?.params?.sesion_id ?? null;
            },
            terminoVisibilidadReducidaKey() {
                return claveVisibilidad('visibilidad_reducida.termino_visibilidad_reducida', this.sesion_id, clave => this.$te(clave));
            }
        },
        components: {
            CondicionesPlazosModal
        }
    }
</script>
<style scoped>
.with-before::before {
    background: white !important;
}
</style>